/**
 * Uniform
 * -------
 * 
 * June 2026
 */

import { InputNumber } from "primereact/inputnumber";

/**
 * Distribution component for editing the parameters of a uniform distribution.
 * 
 * @param {String} elementType      - Type of element tied to distribution. (actions, resources, entity_types)
 * @param {Object} element          - Attributes for an element being edited.
 * @param {Object} attr             - Distribution parameters tied with element attribute.
 * @param {Function} distUpdater    - Sets which distribution is currently being used.
 * @param {Function} warningUpdater - Updates warnings for an element parameter.
 * @param {Object} configWarnings   - Verification warnings for model elements.
*/
function Uniform({ elementType, element, attr, distUpdater, warningUpdater, configWarnings }) {
    const uniformWarnings = {
        'lower_bound': function(newRange) { return !newRange.lower_bound || !(newRange.lower_bound < newRange.upper_bound)? `${attr} - Lower bound must be less than upper bound` : null },
        'upper_bound': function(newRange) { return !newRange.upper_bound || !(newRange.upper_bound > newRange.lower_bound) ? `${attr} - Upper bound must be greater than lower bound` : null }
    }
    
    /**
     * Updates the uniform distribution parameters for an attribute.
     * 
     * Example parameters:
     *  - lower bound
     *  - upper bound
     * 
     * @param {String} uniformParam - Uniform parameter being updated.
     * @param {float} newValue      - Updated value for the uniform parameter. 
     */
    const handleUniform = (uniformParam, newValue) => {
        const newUniform = {...element[attr].attr, [uniformParam]: newValue};
        const newDist = {...element[attr], attr: newUniform};

        const lowerBoundWarning = uniformWarnings['lower_bound'](newUniform);
        const upperBoundWarning = uniformWarnings['upper_bound'](newUniform);
        warningUpdater(element.gid, attr, lowerBoundWarning || upperBoundWarning);

        // console.log("New uniform distribution: ", newUniform);
        distUpdater(attr, newDist);
    }

    return (
        <div>
            <div style={{ marginBottom: '0.5rem' }}>
                <label style={{ marginRight: '0.5rem' }}>Lower Bound:</label>
                <InputNumber value={element[attr].attr.lower_bound} onValueChange={(event) => handleUniform('lower_bound', event.target.value)} invalid={!!configWarnings[elementType]?.[element.gid]?.[attr]} inputStyle={{ width: '110px' }}/>
            </div>
            <div style={{ marginBottom: '0.5rem' }}>
                <label style={{ marginRight: '0.5rem' }}>Upper Bound:</label>
                <InputNumber value={element[attr].attr.upper_bound} onValueChange={(event) => handleUniform('upper_bound', event.target.value)} invalid={!!configWarnings[elementType]?.[element.gid]?.[attr]} inputStyle={{ width: '110px' }}/>
            </div>
        </div>
    )
}

export default Uniform;